import React from "react";

import { useMediaQuery } from "react-responsive";

import { animatedItems } from "../../../config/animatedItemsData";

import { AnimatedBlockMobile } from "./AnimatedBlockMobile";
import {
  AnimatedItem,
  AnimatedSection,
  Circle,
  ContentBlock,
  Description,
  Icon,
  ImgBlock,
  List,
  ListItem,
  Number,
  NumberBlock,
  Text,
  Title,
  TitleStrong,
} from "./styles";

export const AnimatedBlock: React.FC = () => {

  const isMobile = useMediaQuery({ maxWidth: 979 });

  if (isMobile) {
    return <AnimatedBlockMobile items={animatedItems} />;
  }

  return (
    <AnimatedSection>
      {animatedItems.map((item, index) => (
        <AnimatedItem
          key={item.number}
          initial={{ opacity: 0, y: index % 2 === 0 ? 50 : -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: false }}
        >
          <ImgBlock src={item.img} />
          <ContentBlock>
            <NumberBlock>
              <Circle />
              <Number>{item.number}</Number>
            </NumberBlock>
            <Title>
              {item.title}
              <span> {item.title_color}</span>
            </Title>
            <Description>{item.description}</Description>
            <TitleStrong>{item.title_strong}</TitleStrong>
            <List>
              {item.answers.map((answer, i) => (
                <ListItem key={i}>
                  <Icon />
                  <Text>{answer}</Text>
                </ListItem>
              ))}
            </List>
          </ContentBlock>
        </AnimatedItem>
      ))}
    </AnimatedSection>
  );
};

